import ManualWrapper from './ManualWrapper'
import DownloadFormButton from './DownloadFormButton'

type DownloadManual = {
  type: string,
  year: string,
  customerNumber: string,
}

const DownloadManual = (props: DownloadManual) => {
  const { type, year, customerNumber } = props

  return (
    <ManualWrapper>
      <h1>Required {type} Manual</h1>
      <h2 className="center">Download and complete all items in your manual.</h2>
      <p className="center">
        Download one copy. If you have purchased a premium package, you will walk through this document with your trainer. Each Section in the manual
        must be completed.
      </p>
      <p className="center color-danger bold">To mark this status as Complete. Please go to the "Checklist" in your {type} portion. Then check off all items you have completed in the Tab that says {type} E-Manual.</p>
      <hr />
      <ul>
        <li>
          Federal Annual {type} Manual
          <DownloadFormButton
            type={type}
            year={year}
            customerNumber={customerNumber}
          />
        </li>
        <hr />
      </ul>
    </ManualWrapper>
  )
}

export default DownloadManual